__turbopack_context__.v({
  "actionButton": "StyledComponents-module__g3P99q__actionButton",
  "actionButtonsContainer": "StyledComponents-module__g3P99q__actionButtonsContainer",
  "active": "StyledComponents-module__g3P99q__active",
  "actualPriceDisplay": "StyledComponents-module__g3P99q__actualPriceDisplay",
  "belowFoldPadding": "StyledComponents-module__g3P99q__belowFoldPadding",
  "cardWrapper": "StyledComponents-module__g3P99q__cardWrapper",
  "cornerStockStatus": "StyledComponents-module__g3P99q__cornerStockStatus",
  "cornerStockStatusVariant": "StyledComponents-module__g3P99q__cornerStockStatusVariant",
  "countryChip": "StyledComponents-module__g3P99q__countryChip",
  "countryChipsContainer": "StyledComponents-module__g3P99q__countryChipsContainer",
  "countryFlagsBox": "StyledComponents-module__g3P99q__countryFlagsBox",
  "countrySelect": "StyledComponents-module__g3P99q__countrySelect",
  "currencyDisplay": "StyledComponents-module__g3P99q__currencyDisplay",
  "description": "StyledComponents-module__g3P99q__description",
  "descriptionHtml": "StyledComponents-module__g3P99q__descriptionHtml",
  "desktopDescriptionSection": "StyledComponents-module__g3P99q__desktopDescriptionSection",
  "detailTitle": "StyledComponents-module__g3P99q__detailTitle",
  "discountCornerRibbon": "StyledComponents-module__g3P99q__discountCornerRibbon",
  "discountCornerRibbonStrip": "StyledComponents-module__g3P99q__discountCornerRibbonStrip",
  "divider": "StyledComponents-module__g3P99q__divider",
  "dividerMy2": "StyledComponents-module__g3P99q__dividerMy2",
  "dividerMy3": "StyledComponents-module__g3P99q__dividerMy3",
  "error": "StyledComponents-module__g3P99q__error",
  "fadeIn": "StyledComponents-module__g3P99q__fadeIn",
  "formSelect": "StyledComponents-module__g3P99q__formSelect",
  "gridContainer": "StyledComponents-module__g3P99q__gridContainer",
  "gridImageCol": "StyledComponents-module__g3P99q__gridImageCol",
  "gridInfoCol": "StyledComponents-module__g3P99q__gridInfoCol",
  "hasError": "StyledComponents-module__g3P99q__hasError",
  "helperText": "StyledComponents-module__g3P99q__helperText",
  "imagePaddingBox": "StyledComponents-module__g3P99q__imagePaddingBox",
  "inStock": "StyledComponents-module__g3P99q__inStock",
  "inputFlexContainer": "StyledComponents-module__g3P99q__inputFlexContainer",
  "loadingFlex": "StyledComponents-module__g3P99q__loadingFlex",
  "mobileDescriptionSection": "StyledComponents-module__g3P99q__mobileDescriptionSection",
  "opacityWrapper": "StyledComponents-module__g3P99q__opacityWrapper",
  "opacityWrapperDisabled": "StyledComponents-module__g3P99q__opacityWrapperDisabled",
  "outOfStock": "StyledComponents-module__g3P99q__outOfStock",
  "outline": "StyledComponents-module__g3P99q__outline",
  "priceInput": "StyledComponents-module__g3P99q__priceInput",
  "priceInputContainer": "StyledComponents-module__g3P99q__priceInputContainer",
  "priceLabel": "StyledComponents-module__g3P99q__priceLabel",
  "priceLoadingIndicator": "StyledComponents-module__g3P99q__priceLoadingIndicator",
  "priceSummaryCard": "StyledComponents-module__g3P99q__priceSummaryCard",
  "priceSummaryCol": "StyledComponents-module__g3P99q__priceSummaryCol",
  "priceSummaryColEnd": "StyledComponents-module__g3P99q__priceSummaryColEnd",
  "priceSummaryFootnote": "StyledComponents-module__g3P99q__priceSummaryFootnote",
  "priceSummaryFootnoteSaving": "StyledComponents-module__g3P99q__priceSummaryFootnoteSaving",
  "priceSummaryFootnoteSep": "StyledComponents-module__g3P99q__priceSummaryFootnoteSep",
  "priceSummaryLabel": "StyledComponents-module__g3P99q__priceSummaryLabel",
  "priceSummaryRow": "StyledComponents-module__g3P99q__priceSummaryRow",
  "priceSummaryValue": "StyledComponents-module__g3P99q__priceSummaryValue",
  "priceSummaryValuePrimary": "StyledComponents-module__g3P99q__priceSummaryValuePrimary",
  "priceSummaryValueSaving": "StyledComponents-module__g3P99q__priceSummaryValueSaving",
  "priceTile": "StyledComponents-module__g3P99q__priceTile",
  "priceTileCountry": "StyledComponents-module__g3P99q__priceTileCountry",
  "priceTileCountryName": "StyledComponents-module__g3P99q__priceTileCountryName",
  "priceTileCurrency": "StyledComponents-module__g3P99q__priceTileCurrency",
  "priceTileExtra": "StyledComponents-module__g3P99q__priceTileExtra",
  "priceTileFlag": "StyledComponents-module__g3P99q__priceTileFlag",
  "priceTileGrid": "StyledComponents-module__g3P99q__priceTileGrid",
  "priceTileHeader": "StyledComponents-module__g3P99q__priceTileHeader",
  "priceTileLabels": "StyledComponents-module__g3P99q__priceTileLabels",
  "priceTileOos": "StyledComponents-module__g3P99q__priceTileOos",
  "priceTileRibbon": "StyledComponents-module__g3P99q__priceTileRibbon",
  "priceTileRibbonStrip": "StyledComponents-module__g3P99q__priceTileRibbonStrip",
  "priceTileSubtitle": "StyledComponents-module__g3P99q__priceTileSubtitle",
  "priceTileValue": "StyledComponents-module__g3P99q__priceTileValue",
  "priceValue": "StyledComponents-module__g3P99q__priceValue",
  "pricingSection": "StyledComponents-module__g3P99q__pricingSection",
  "productContainer": "StyledComponents-module__g3P99q__productContainer",
  "productImageContainer": "StyledComponents-module__g3P99q__productImageContainer",
  "productImageWrapper": "StyledComponents-module__g3P99q__productImageWrapper",
  "productInfo": "StyledComponents-module__g3P99q__productInfo",
  "productSubtitle": "StyledComponents-module__g3P99q__productSubtitle",
  "quantityButton": "StyledComponents-module__g3P99q__quantityButton",
  "quantityControl": "StyledComponents-module__g3P99q__quantityControl",
  "quantityInput": "StyledComponents-module__g3P99q__quantityInput",
  "quantitySection": "StyledComponents-module__g3P99q__quantitySection",
  "quantitySectionTitle": "StyledComponents-module__g3P99q__quantitySectionTitle",
  "rangeInputBox": "StyledComponents-module__g3P99q__rangeInputBox",
  "rangeText": "StyledComponents-module__g3P99q__rangeText",
  "saving": "StyledComponents-module__g3P99q__saving",
  "savingsInfo": "StyledComponents-module__g3P99q__savingsInfo",
  "sectionCard": "StyledComponents-module__g3P99q__sectionCard",
  "sectionIcon": "StyledComponents-module__g3P99q__sectionIcon",
  "sectionTitle": "StyledComponents-module__g3P99q__sectionTitle",
  "selectWrapper": "StyledComponents-module__g3P99q__selectWrapper",
  "selected": "StyledComponents-module__g3P99q__selected",
  "slideIn": "StyledComponents-module__g3P99q__slideIn",
  "specLabel": "StyledComponents-module__g3P99q__specLabel",
  "specValue": "StyledComponents-module__g3P99q__specValue",
  "specificationItem": "StyledComponents-module__g3P99q__specificationItem",
  "specificationList": "StyledComponents-module__g3P99q__specificationList",
  "starRatingWrapper": "StyledComponents-module__g3P99q__starRatingWrapper",
  "stepItem": "StyledComponents-module__g3P99q__stepItem",
  "stepList": "StyledComponents-module__g3P99q__stepList",
  "stepNote": "StyledComponents-module__g3P99q__stepNote",
  "stepNumber": "StyledComponents-module__g3P99q__stepNumber",
  "stepText": "StyledComponents-module__g3P99q__stepText",
  "stepperButton": "StyledComponents-module__g3P99q__stepperButton",
  "stockBadgeInline": "StyledComponents-module__g3P99q__stockBadgeInline",
  "stockLeft": "StyledComponents-module__g3P99q__stockLeft",
  "stockStatus": "StyledComponents-module__g3P99q__stockStatus",
  "trustBadge": "StyledComponents-module__g3P99q__trustBadge",
  "trustBadgesContainer": "StyledComponents-module__g3P99q__trustBadgesContainer",
  "trustLabelItem": "StyledComponents-module__g3P99q__trustLabelItem",
  "trustLabelsContainer": "StyledComponents-module__g3P99q__trustLabelsContainer",
  "updatesToggleIcon": "StyledComponents-module__g3P99q__updatesToggleIcon",
  "wishlistToggleIcon": "StyledComponents-module__g3P99q__wishlistToggleIcon",
});
